package navigation.settings.imagegallery

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.file.ui.essntlgallery.EssntlGalleryEvent
import com.essntl.features.file.ui.essntlgallery.EssntlGalleryState
import com.essntl.features.file.ui.essntlgallery.EssntlGalleryViewModel

class ImageGalleryScreenModel(
    fileRepository: FileRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<EssntlGalleryState>(EssntlGalleryState()) {

    private val viewModel =
        EssntlGalleryViewModel(
            entity = null,
            fileRepository = fileRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: EssntlGalleryEvent) = viewModel.onEvent(event)
}